import { Language } from './language';

const pt = {
    code: Language.pt,

	// HOME PAGE

	t_description: 'Menina baterista, {age} anos',
	t_close: 'Fechar',
	
	b_home: 'Início',
	b_about: 'Sobre mim',
	b_press: 'Imprensa e Mídia',
	b_shows: 'Apresentações ao vivo',
	b_latest_show: 'Recente',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'Português',
	b_share: 'Compartilhar',
	b_scroll_to_top: 'Vá para começar',
	b_click: 'Clique',
	b_tap: 'Pressiona',

	t_english: 'Inglês',
	t_spanish: 'Espanhol',
	t_portuguese: 'Português',
	t_italian: 'Italiano',
	t_french :'Francês',
	t_german: 'Alemão',
	t_chinese: 'Chinês',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'Festival KRFK Come Together',
	KRKComeTogether2026DROM_description: 'DROM, Nova York, NY',

	KRKComeTogether2026Chelsea_title: 'Festival KRFK Come Together',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage, Nova York, NY',

	RockFantasy2026Whisky_title: 'Acampamento Fantasia do Rock and Roll',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Acampamento Fantasia do Rock and Roll',
	RockFantasy2026Viper_description: 'The Viper Room, Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Celebração da Luz de Fulcrum',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Tributo ao Queen',
	QueenTribute_description: 'School of Rock Seattle',

	FremontFridays2025_title: 'Sextas-feiras de Fremont 2025',
	FremontFridays2025_description: 'Sextas-feiras de Fremont em Seattle',

	DrumFantasyCamp2025_title: 'Camp Drum Fantasy 2025',
	DrumFantasyCamp2025_description: 'Camp Drum Fantasy em Los Angeles',

	ClassicMetal_title: 'Metal Clássico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Apresentação do Dia dos Avós 2024',
	StAlsGrandDay2024_description: 'Escola Santo Afonso em Seattle',

	BlackViolinConcert_title: 'Concerto de Violino Negro com The World Your Orchestra',
	BlackViolinConcert_description: 'O Teatro Paramount',

	MexicanIndependenceDay2024_title: 'Celebração da Independência do México com a Orquestra Cívica Ballard',
	MexicanIndependenceDay2024_description: 'Prefeitura de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival de Frutos do Mar Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival de Frutos do Mar Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Metal Moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Prévia da Temporada Inverno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Show de Talentos 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Prévia da Temporada Primavera de 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Os Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Show da Trilha Sonora',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia dos anos 90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Show de Talentos 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Veja aqui',

	king_5_feature_title: 'Reportagem Fulcrum / King 5',
	king_5_feature_description: 'Reportagem da Seattle King 5 TV patrocinada pela Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Entrevista no canal do YouTube Bateristland',

	komo_news_title: 'Reportagem na Komo News',
	komo_news_description: 'Entrevista na Seattle Refined',

	andrew_rooney_drums_title: 'Reação de Andrew Rooney',
	andrew_rooney_drums_description: 'Andrew Rooney reage à performance de Victoria de Tom Sawyer, do Rush',

	upper_lefters_interview_title: 'Entrevista Upper Lefters',
	upper_lefters_interview_description: 'Entrevista no canal do YouTube Upper Lefters sobre a carreira da Victoria e seus planos para o futuro',

	the_eagle_969_title: '96.9 The Eagle Estação de Rádio de Clássicos',
	the_eagle_969_description: 'Post no blog da 96.9 The Eagle Classic Hits sobre o cover de Rush da Victoria',

	fox_13_news_title: 'Relatório de notícias da Fox 13 Seattle',
	fox_13_news_description: 'Relatório na seção "True Northwest"',

	the_daly_migs_show_interview_title: 'Entrevista com The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Entrevista sobre ser convidado para subir ao palco com Godsmack',

	alizee_defan_07_02_2024_title: 'Entrevista com "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Entrevista exclusiva',

	jaime_mendez_news_06_26_2024_title: 'Entrevista "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Notícias locais de Seattle em espanhol',

	bien_informado_03_22_2023_title: 'Artigo de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Artigo do site de notícias argentino sobre Victoria',

	wave_potter_reaction_01_30_2023_title: 'A reação de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reage ao cover de Victoria Lux Æterna do Metallica',
	
	// ABOUT PAGE

	b_back: 'Volte',

	t_title: 'Victoria Acosta',
	t_pronouns: '(ela)',

	b_read_more: 'Leia mais',
	b_read_less: 'Leia menos',
	b_stat_age: 'Idade',
	b_stat_shows: 'Shows ao Vivo',
	b_stat_yrs: 'Anos de Bateria',
	b_stat_awards: 'Prêmios',

	t_about:`
Com baquetas nas mãos e ritmo na alma, Victoria Acosta, de {age} anos, é uma das jovens bateristas mais promissoras da atualidade. Nascida em El Paso, Texas, criada em Guadalajara, México, e hoje morando em Seattle, é conhecida por sua dedicação, energia e presença de palco.

Victoria começou a tocar bateria aos quatro anos e recebeu sua primeira bateria em 13 de setembro de 2018. Estudou na Musicalerias Academy, em Guadalajara, e continuou sua formação em Seattle. Após uma aula experimental na School of Rock em 29 de maio de 2022, pulou o Rock 101 e entrou diretamente no Performers Program. Desde então, apresentou-se em {shows} shows ao vivo.

Ela gravou centenas de vídeos para as redes sociais e, em 13 de junho de 2024, foi convidada pelo compositor italiano Alberto Rigonni como baterista convidada em Nemesis Call. Recebeu um endorsement da Soultone Cymbals em 12 de setembro de 2024 e entrou para o roster de artistas da Collision Drumsticks em 8 de março de 2025.

Em agosto de 2025, Victoria participou do Drum Fantasy Camp em Los Angeles, estudando com Dave Weckl, Dennis Chambers, Peter Erskine e Gavin Harrison. No mesmo mês, começou a estudar com o professor Dave Stark, cuja orientação continua desenvolvendo sua técnica, musicalidade e expressão artística.

Em 13 de fevereiro de 2026, Victoria tornou-se artista Paiste. Nesse mês, também participou do Rock and Roll Fantasy Camp, tocou com Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter e Leland Sklar, e se apresentou no Viper Room e no Whisky a Go Go. Em 2026, ganhou a bolsa de estudos Neil Peart Drum Set, concedida pela Percussive Arts Society e Hudson.

Além da bateria, Victoria começou a estudar violino na quarta série e entrou para a World Youth Orchestra em 2024. Dividiu o palco com Black Violin no Paramount Theatre e estreou como percussionista com a Ballard Civic Orchestra no Town Hall Seattle durante uma celebração da Independência do México.

Entre suas conquistas estão o Gold Prize e o Fantastic Technique Award do London Young Musician Contest 2022, além do Annual Star Musician Award e do Outstanding Drummer Special Award em 2023. Victoria pratica diariamente, superando seus limites com determinação e criatividade.
`,

	// PRESS PAGE

	t_footer: 'Todos os direitos reservados',

	// SOULTONE: 

	b_visit_artist_page: 'Visite minha página de artista'

};

export default pt;
